<template>
	<div class="sale-detail-info-wrap">
		<van-collapse v-model="activeNames">
		  <van-collapse-item name="1">
		    <template #title>
		      <div>基本信息</div>
		    </template>
		    <div class="detail-item"><div class="detail-label">订单号：</div><div class="detail-value">{{ info.ordercode }}</div></div>
		    <div class="detail-item"><div class="detail-label">合同编号：</div>{{ info.ordernumber }}</div>
		    <div class="detail-item"><div class="detail-label">客户：</div><div class="detail-value">{{ info.receiver }}</div></div>
		    <div class="detail-item"><div class="detail-label">销售公司：</div> {{ info.company_name }}</div>
		    <div class="detail-item"><div class="detail-label">建单人：</div><div class="detail-value">{{ info.operator}}</div></div>
		    <div class="detail-item"><div class="detail-label">销售员：</div><div class="detail-value">{{ info.seller }}</div></div>
		    <div class="detail-item"><div class="detail-label">TEAM：</div> {{ info.team }}</div>
		    <div class="detail-item"><div class="detail-label">是否开票：</div> {{ info.isinvoice_text }}</div>
		    <div class="detail-item"><div class="detail-label">结算方式：</div> {{ info.settlementtype_text }}</div>
		    <div class="detail-item"><div class="detail-label">付款方式：</div> {{ info.paytype_text }}</div>
		    <div class="detail-item"><div class="detail-label">付款状态：</div> {{ info.paystatus_text }}</div>
		    <div class="detail-item"><div class="detail-label">合同交期：</div> {{ info.deliverytime_text }}</div>
		    <div class="detail-item"><div class="detail-label">交货地点：</div> {{ info.deliveryplace }}</div>
				<div class="detail-item"><div class="detail-label">Tel&Attn：</div>{{ info.attn }}</div>
				<div class="detail-item"><div class="detail-label">Payment：</div> {{ info.payment }}</div>
				<div class="detail-item"><div class="detail-label">收款摘要：</div>{{ info.collection_summary }}</div>
				<div class="detail-item"><div class="detail-label">备注：</div><div class="detail-value">{{ info.remark }}</div></div>
		  </van-collapse-item>
		</van-collapse>
	</div>
</template>

<script>
	export default {
		components: {
		},
		props: {
			id: {
				type: [String, Number],
				default: () => {
					return 0;
				}
			}
		},
		data() {
		  return {
				loading: false,
				activeNames: [
					"1"
				],
				info: {},
		  };
		},
		watch: {},
		created() {
		  this.init();
		},
		mounted() {},
		methods: {
		  init() {
				this.getData()
			},
			// 获取数据内容
			getData() {
				this.loading = true;
				this.$post(this.$api.stGetXiaoshouoDetail, {id: this.id}).then((res) => {
					if (res.code == 200) {
						let data = res.data;
						let settlementtype = this.$option.settlementtype.find((v) => { return v.value == data.settlementtype; });
						data.settlementtype_text = settlementtype ? settlementtype.text : '';
						this.info = data;
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
					this.loading = false;
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.sale-detail-info-wrap {
		margin: 24px;
		border-radius: 5px;
		::v-deep .van-collapse-item__title {
			background-color: #d2d6de;
		}
		
		.detail-label {
			width: 92px;
			text-align: right;
			display: inline-block;
			flex-shrink: 0;
			white-space: nowrap;
		}
		
		.detail-item {
			margin-top: 8px;
			display: flex;
			align-items: flex-start;
			line-height: 1.4;
		}

		.detail-value {
			flex: 1;
			padding-left: 4px;
			word-break: break-word;
		}
	}
</style>